import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import Style from '../PlaybackError.module.scss';

const supportUrl = _.get(window.ExternalConfig, 'support.url');

const Geolocation = props => {
  const {
    headerText,
    bodyText,
    linkText,
    actionButtonText,
    primaryActionCallback,
    geoLocationTimeoutFail,
    url,
  } = props;
  const actionButton = primaryActionCallback ? (
    <button
      onClick={() => {
        primaryActionCallback();
      }}
      className={Style.primaryAction}
      type="button"
    >
      {actionButtonText}
    </button>
  ) : null;

  const bodyClass = geoLocationTimeoutFail ? Style.failBodyText : Style.bodyText;

  return (
    <div className={classNames([Style.errorContainer, Style.location])}>
      <div className={Style.headerText}>{headerText}</div>
      <div className={bodyClass}>{bodyText}</div>
      <div className={Style.actions}>{actionButton}</div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={Style.issues}
        type="button"
      >
        {linkText}
      </a>
    </div>
  );
};

export default Geolocation;

Geolocation.defaultProps = {
  actionButtonText: '',
  bodyText: '',
  geoLocationTimeoutFail: false,
  headerText: '',
  linkText: '',
  primaryActionCallback: () => {},
  url: supportUrl,
};

Geolocation.propTypes = {
  actionButtonText: PropTypes.string,
  bodyText: PropTypes.string,
  geoLocationTimeoutFail: PropTypes.bool,
  headerText: PropTypes.string,
  linkText: PropTypes.string,
  primaryActionCallback: PropTypes.func,
  url: PropTypes.string,
};
